import { render, staticRenderFns } from "./IndicatorsWizard.vue?vue&type=template&id=f018daec&scoped=true&"
import script from "./IndicatorsWizard.vue?vue&type=script&lang=js&"
export * from "./IndicatorsWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f018daec",
  null
  
)

export default component.exports